module.exports = __webpack_public_path__ + "static/media/AF.3cd2ecee.png";